<div class="enrollment-card ontario-row ontario-margin-top-16-!">
  <div class="ontario-row card-title-div">
    <div class="ontario-column small-height ontario-small-12 ontario-large-1 ontario-medium-6">
      @if (enrolmentStatus == 'pending' || enrolmentStatus == 'cancelled') {
        <app-checkbox #masterCheckBox (checkedChange)="setChildCheckBox($event)"> </app-checkbox>
      }
      &nbsp;
    </div>
    <div class="ontario-column small-height ontario-small-12 ontario-large-2 ontario-medium-6">
      <div class="card-label">{{'Contact.FirstName' | translate}}</div>
    </div>
    <div class="ontario-column small-height ontario-small-12 ontario-large-2 ontario-medium-6">
      <div class="card-label">{{'Contact.LastName' | translate}}</div>
    </div>
    <div class=" ontario-column small-height ontario-small-12 ontario-large-2 ontario-medium-6">
      <div class="card-label">{{'ClassEnrolment.Email' | translate}}</div>
    </div>
    <div class=" ontario-column small-height ontario-small-12 ontario-large-2 ontario-medium-6">
      <div class="card-label inline-block">{{'ClassEnrolment.Phone' | translate}}</div>
    </div>
    <div class=" ontario-column fit-height ontario-small-12 ontario-large-3 ontario-medium-6">
      @if (enrolmentStatus== 'pending') {
        <label class="card-title-badge status-pending">{{'ClassEnrolment.EnrolmentRequestPending' | translate}}</label>
      }
      @if (enrolmentStatus== 'enrolled') {
        <label class="card-title-badge status-enrolled">{{'ClassEnrolment.Enrolled' | translate}}</label>
      }
      @if (enrolmentStatus== 'cancelled') {
        <label class="card-title-badge status-cancelled">{{'ClassEnrolment.Cancelled' | translate}}</label>
      }
      @if (classEnrollment.LearnerCount!>1) {
        <label class="card-title-badge no-seats">{{classEnrollment.LearnerCount}} {{'ClassEnrolment.Seats' | translate}}</label>
      }
      @if (classEnrollment.Enrolments.length>0) {
        <label class="card-title-updated">{{'ClassEnrolment.Updated' | translate}}: {{ classEnrollment.Enrolments[0].LastUpdatedDate | date:'MMM d, y'}}</label>
      }
    </div>
  </div>
  @for (enrolment of classEnrollment.Enrolments; track enrolment; let i = $index) {
    <div class="ontario-row card-content">
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-1 ontario-medium-6 banner-container">
        @if ((enrolmentStatus == 'pending' || enrolmentStatus == 'cancelled') && (enrolment.EnrolmentStatus==0 || enrolment.EnrolmentStatus==-1) && enrolment.EnrolmentGroupId && (!enrolment.IsPrimary || enrolment.IsPrimaryLearner)) {
          <app-checkbox #childCheckBox (checkedChange)="setMasterCheckBox($event, enrolment.RegistrationId)">
          </app-checkbox>
        }
        &nbsp;
        @if (enrolment.isInfoIncomplete) {
          <label matTooltip="{{'ClassEnrolment.EnrolIncompleteInfo' | translate}}" class="incomplete-info-badge info-banner-pos"></label>
        }
      </div>
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
        <div class="card-info break-word">{{enrolment?.FirstName}}</div>
      </div>
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
        <div class="card-info break-word">{{enrolment?.LastName}}</div>
      </div>
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
        <div class="card-info break-word">{{enrolment?.EmailAddress}}</div>
      </div>
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-2 ontario-medium-6">
        <div class="card-info no-wrap">
          {{enrolment?.Phone | phone}}
        </div>
      </div>
      <div [class.no-border]="i == classEnrollment.Enrolments.length - 1" class="ontario-column ontario-small-12 ontario-large-3 ontario-medium-6">
        <div class="card-info">
          @if (((enrolment.IsPrimary|| enrolment.IsPrimaryLearner) && enrolment?.EnrolmentGroupId) || !enrolment?.EnrolmentGroupId) {
            <a class="view-link right-most" [routerLink]="[this.currentLang == 'en'? '/training-provider/enrolment/' + enrolment.CourseId + '/tp': '/fr/training-provider/enrolment/' + enrolment.CourseId + '/tp']"
            [queryParams]="{GroupOrRegId: enrolment?.EnrolmentGroupId ?? enrolment.RegistrationId, status: enrolmentStatus, EnrollmentFlowType: ENROLLMENT_FLOW_TYPE.PendingEdit}">view details</a>
          }
          @if (enrolment.IsPrimaryLearner) {
            <label class="primary-contact-badge">{{'ClassEnrolment.PrimaryContactLearner' | translate}}</label>
          }
          @if (!enrolment.IsPrimaryLearner && enrolment.IsPrimary) {
            <label class="primary-contact-badge">{{'ClassEnrolment.PrimaryContact' | translate}}</label>
          }
          @if (enrolment.OptInForEmail || enrolment.OptInForText) {
            <label class="primary-contact-badge">{{'ClassEnrolment.Subscribed' | translate}}</label>
          }
        </div>
      </div>
    </div>
  }
</div>
